export const DoughnutData = (canvas) => {
  const ctx = canvas.getContext('2d')
  const gradient1 = ctx.createLinearGradient(206, 159, 252, 1)
  gradient1.addColorStop(0, '#CE9FFC')
  gradient1.addColorStop(1, '#7367F0')
  const gradient2 = ctx.createLinearGradient(116, 249, 241, 0)
  gradient2.addColorStop(0, '#74F9F1')
  gradient2.addColorStop(1, '#74F9F1')
  const gradient3 = ctx.createLinearGradient(255, 233, 133, 1)
  gradient3.addColorStop(0, '#FFE985')
  gradient3.addColorStop(1, '#FA742B')
  const gradient4 = ctx.createLinearGradient(255, 246, 183, 1)
  gradient4.addColorStop(0, '#FFF6B7')
  gradient4.addColorStop(1, '#F6416C')
  return {
    labels: ['Aging', 'Amber', 'Cold', 'Hot'],
    datasets: [
      {
        label: 'My First Dataset',
        data: [25, 25, 25, 25],
        backgroundColor: [gradient2, gradient3, gradient4, gradient1],
        hoverOffset: 4,
      },
    ],
  }
}
export const DoughnutOptions = {
  legend: {
    display: true,
    position: 'right',
    maxWidth: 140,
    reverse: true,
  },
  tooltips: {
    display: true,
  },
  elements: {
    arc: {
      borderWidth: 0,
    },
  },
}

export default { DoughnutData, DoughnutOptions }
